import React from 'react';

interface CallStatusViewProps {
  error?: string | null;
  isCalling: boolean;
  hasToken: boolean;
  children?: React.ReactNode;
}

export function CallStatusView({ error, isCalling, hasToken, children }: CallStatusViewProps) {
  if (error && !hasToken) {
    return (
      <div className="flex items-center justify-center p-8">
        <div className="text-center">
          <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg">
            <p className="text-red-600 text-sm">{error}</p>
          </div>
        </div>
      </div>
    );
  }

  if (isCalling && !hasToken) {
    return (
      <div className="flex items-center justify-center p-8">
        <div className="text-center">
          <div className="text-4xl mb-4 animate-pulse">📞</div>
          <p className="text-gray-600">Connecting to call...</p>
        </div>
      </div>
    );
  }

  // Only show empty state if there's an error or we're calling, otherwise show children
  // This allows call records to be displayed even when there's no active call token
  if (error) {
    return (
      <div className="flex items-center justify-center p-8">
        <div className="text-center">
          <div className="text-4xl mb-4">❌</div>
          <h3 className="text-lg font-semibold text-red-700 mb-2">Error</h3>
          <p className="text-red-500">{error}</p>
        </div>
      </div>
    );
  }

  // Always render children - let WhatsAppCallsTab handle its own empty state
  return <>{children}</>;
}
